import { EntityTypeFields, FieldTemplate, TemplateRow } from '../../../app/components/fields-template/field-template';
import type { basePheFields, basePlanningFields } from '../entitytypes';
import { REPETITION_ROWS } from './repetition';

type BaseET = {
    fields_planning: typeof basePlanningFields;
    fields_phe: typeof basePheFields;
    // Losse index-signature (i.p.v. `typeof basePlanningDataFields`): entity-type-templates die BASE_ROWS
    // spreiden (blast/markings/wipe) hebben een fields_planning_data met extra sleutels bovenop
    // basePlanningDataFields. Met een exacte type hier is BaseET niet meer structureel toewijsbaar aan die
    // bredere entity-type-varianten (TS vergelijkt de generic TemplateNode<ET> instanties dan niet meer los
    // per fieldGroup-branch).
    fields_planning_data?: Record<string, unknown> | null;
    fields_phe_data?: Record<string, unknown> | null;
};

export const BASE_ROWS: TemplateRow<BaseET>[] = [
    {
        type: 'row',
        children: [
            {
                type: 'div',
                classes: 'col-xl-18 col-md-24',
                children: [
                    {
                        type: 'row',
                        children: [
                            {
                                type: 'field',
                                fieldKey: 'status_key',
                                fieldGroup: 'planning',
                                classes: 'col-24 col-md-4',
                            },
                            {
                                type: 'field',
                                fieldKey: 'afas_customer_id',
                                fieldGroup: 'planning',
                                classes: 'col-24 col-md-6',
                            },
                            {
                                type: 'field',
                                fieldKey: 'afas_project_id',
                                fieldGroup: 'planning',
                                classes: 'col-24 col-md-6',
                            },
                            { type: 'field', fieldKey: 'location', fieldGroup: 'planning', classes: 'col-24 col-md' },
                        ],
                    },
                    {
                        type: 'row',
                        children: [
                            {
                                type: 'field',
                                fieldKey: 'begindate',
                                fieldGroup: 'phe',
                                classes: 'col-24 col-md-8 col-lg-7',
                            },
                            {
                                type: 'field',
                                fieldKey: 'enddate',
                                fieldGroup: 'phe',
                                classes: 'col-24 col-md-8 col-lg-7',
                            },
                            { type: 'field', fieldKey: 'performer', fieldGroup: 'planning', classes: 'col-12 col-md' },
                            { type: 'field', fieldKey: 'projectmanager', fieldGroup: 'planning', classes: 'col' },
                        ],
                    },
                    {
                        type: 'row',
                        children: [
                            {
                                type: 'field',
                                fieldKey: 'execute_after_date',
                                fieldGroup: 'planningData',
                                classes: 'col-24 col-md-8 col-lg-7',
                            },
                        ],
                    },
                    ...REPETITION_ROWS,
                ],
            },
            { type: 'field', fieldKey: 'comment', fieldGroup: 'planning', classes: 'col-xl col-md-24' },
        ],
    },
];

export class BaseTemplate implements FieldTemplate {
    rows: TemplateRow<EntityTypeFields>[] = [...(BASE_ROWS as TemplateRow<EntityTypeFields>[])];
}
